<template>
    <div>
        <v-dialog v-model="mostrar" persistent max-width="720px">
            <v-card>
                <v-card-title>
                <span class="headline">Enviar Maxisaco a Reproceso o Repaso</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                v-model="lote_seleccionado"
                                :items="lotes"
                                item-text="nombre_lote"
                                item-value="id"
                                label="Seleccione Lote"
                                color="blue darken-3"
                                persistent-hint
                                return-object
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                v-model="jumbo_seleccionado"
                                :items="jumbos_select"
                                item-text="nro_jumbo"
                                item-value="id"
                                label="Seleccione Maxisaco"
                                color="blue darken-3"
                                persistent-hint
                                return-object
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
                <!-- <small>*indicates required field</small> -->
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" dark @click="limpiar">Cancelar</v-btn>
                <v-btn color="orange darken-1" class="white--text" @click="confirmar" :disabled="!habilitar">Enviar</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
export default {
    data:()=>({
        lotes:[],
        jumbos:[],
        lote_seleccionado:'',
        jumbo_seleccionado:'',
        mostrar:false,
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_jumbo_reproceso');
    },
    mounted() {
        Event.$on('abrir_modal_jumbo_reproceso',async()=>{
            //this.mostrarLoading('Cargando...');
            this.mostrarLoading({titulo:'Cargando...',color:'green'})
            
            await this.cargarLotes();
            this.ocultarLoading();
            this.mostrar = true;
        });
    },
    methods: {
        async cargarLotes(){
            let url = `${this.base_url}lote/jumbos_sin_rechazar`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('lotes con jumbos sin rechazar',response);
                this.lotes = response.data.lotes;
                this.jumbos = response.data.jumbos;
            }).catch((error)=>{
                console.log('error',error);
            });
        },

        async confirmar(){
            let url = `${this.base_url}jumbo/${this.jumbo_seleccionado.id}/reproceso`;
            let body = {
                repaso_jumbos_id:1,
                fecha_repaso: this.moment().format('YYYY-MM-DD HH:mm'),
            };
            await this.axios.put(url,body,this.headers).then((response)=>{
                console.log('respuesta jumbo rechazado',response);
                Event.$emit('actualizar_jumbos_reproceso');
                this.limpiar();
            }).catch((error)=>{
                console.log('error',error);
                this.limpiar();
            });
        },

        limpiar(){
            this.lotes = [];
            this.jumbos = [];
            this.lote_seleccionado = '';
            this.jumbo_seleccionado = '';
            this.mostrar = false;
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['headers','base_url']),

        jumbos_select(){
            let jumbos = [];
            if(this.lote_seleccionado!=''){
                this.jumbos.forEach(j => {
                    if(j.lotes_id==this.lote_seleccionado.id){
                        jumbos.push(j);
                    }
                });
            }
            return jumbos;
        },

        habilitar(){
            if(this.lote_seleccionado != '' && this.jumbo_seleccionado != ''){
                return true;
            }
            return false;
        },
    },
}
</script>